// extracted by mini-css-extract-plugin
module.exports = {"search":"er","light":"es","primary":"et","searchTitle":"eu","searchPanel":"ev","searchPanelRow":"ew","searchButton":"ex"};